import { placeSelectionInsideBlock } from "../selection.js";
import { ManuscriptWidget } from "./base.js";

export class BeginWidget extends ManuscriptWidget {
    constructor(environment) {
        super();
        this.environment = environment;
        this.destroyed = false;
    }

    toDOM(view) {
        this.destroyed = false;
        const element = document.createElement("div");
        this.buildElement(element, view);

        element.addEventListener("mouseup", (event) => {
            event.preventDefault();
            view.dispatch(placeSelectionInsideBlock(view, event));
        });

        return element;
    }

    eq(widget) {
        return widget.environment === this.environment;
    }

    updateDOM(element, view) {
        this.destroyed = false;
        element.textContent = "";
        element.className = "";
        this.buildElement(element, view);
        return true;
    }

    destroy() {
        this.destroyed = true;
    }

    ignoreEvent(event) {
        return event.type !== "mouseup";
    }

    buildName(name) {
        name.textContent = this.environment;
    }

    buildElement(element) {
        element.classList.add("ol-cm-begin", `ol-cm-begin-${this.environment}`);

        const startPadding = document.createElement("span");
        startPadding.classList.add("ol-cm-environment-padding", "ol-cm-environment-start-padding");
        element.appendChild(startPadding);

        const name = document.createElement("span");
        name.classList.add("ol-cm-environment-name");
        this.buildName(name);
        element.appendChild(name);

        const endPadding = document.createElement("span");
        endPadding.classList.add("ol-cm-environment-padding", "ol-cm-environment-end-padding");
        element.appendChild(endPadding);
    }
}
